import { SubscriptionSchedule } from "./SubscriptionSchedule";
import { SlidePayload, BulkExportPayload, SavedBulkExportPayload } from "./SubscriptionPayload";

export enum SubscriptionItemType {
  Slide = 0,
  BulkExport = 1,
  SavedBulkExport = 2,
}

export enum FileFormat {
  XLSX = 0,
  CSV = 1,
}
interface SubscriptionItemBaseDraft {
  type: SubscriptionItemType;
  name: string;
  fileFormat: FileFormat;
  schedule: SubscriptionSchedule;
  payload: Object;
}
export interface SubscriptionSlideItemDraft extends SubscriptionItemBaseDraft {
  type: SubscriptionItemType.Slide;
  payload: SlidePayload;
}
export interface SubscriptionBulkExportItemDraft extends SubscriptionItemBaseDraft {
  type: SubscriptionItemType.BulkExport;
  payload: BulkExportPayload;
}
export interface SubscriptionSavedBulkExportItemDraft extends SubscriptionItemBaseDraft {
  type: SubscriptionItemType.SavedBulkExport;
  payload: SavedBulkExportPayload;
}
export type SubscriptionItemDraft = SubscriptionSlideItemDraft | SubscriptionBulkExportItemDraft | SubscriptionSavedBulkExportItemDraft;

interface SubscriptionItemBase extends SubscriptionItemBaseDraft {
  id: number;
  date: string;
}
export interface SubscriptionSlideItem extends SubscriptionItemBase {
  type: SubscriptionItemType.Slide;
  payload: SlidePayload;
}
export interface SubscriptionBulkExportItem extends SubscriptionItemBase {
  type: SubscriptionItemType.BulkExport;
  payload: BulkExportPayload;
}
export interface SubscriptionSavedBulkExportItem extends SubscriptionItemBase {
  type: SubscriptionItemType.SavedBulkExport;
  payload: SavedBulkExportPayload;
}

export type SubscriptionItem = SubscriptionSlideItem | SubscriptionBulkExportItem | SubscriptionSavedBulkExportItem;
